import React, { useState, useRef } from "react";
import ColorPicker from "fantastic/components/common/ColorPicker";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";

import connectProps from "fantastic/lib/connectProps";
import usedColors from "fantastic/lib/usedColors";
import utils from "fantastic/lib/utils";

import ColorButton from "./ColorButton";
import ImageSettings from "./ImageSettings";
import RemoveImageButton from "./RemoveImageButton";
import SelectImageButton from "./SelectImageButton";

const { url } = utils;

const Settings = props => {
  const { label = i18n.t('background'), onlyColor, defaultColor = "transparent" } = props;
  const color = props.color.value || "transparent";
  const formGroup = useRef(null);
  const colorButtonEl = useRef(null);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const openColorPicker = () => {
    const { scrollToIfNeeded } = props;
    setDisplayColorPicker(!displayColorPicker);
    if (scrollToIfNeeded) scrollToIfNeeded(formGroup.current);
  };

  const closeColorPicker = ({ target }) => {
    if (colorButtonEl.current.contains(target)) return;
    setDisplayColorPicker(false);
  };

  const handleColorChange = color => {
    const {
      onChange,
      color: { field }
    } = props;
    const newValue = color.hex === "transparent" ? "" : color.hex;
    onChange(field, newValue);
  };

  const removeImage = () => {
    const {
      onChange,
      image: { field }
    } = props;
    onChange(field, "none");
  };

  const applySelectedImage = ({ url }) => {
    const {
      onChange,
      image: { field }
    } = props;
    onChange(field, url);
  };

  const openWarehouse = () => {
    warehouseLoader.show(applySelectedImage);
  };

  return (
    <>
      <div className="form-group" ref={formGroup}>
        <label>{label}</label>
        <div>
          <div className="btn-group btn-group-block">
            <ColorButton
              color={color}
              onlyColor={onlyColor}
              onClick={openColorPicker}
              buttonRef={colorButtonEl}
            />
            {!onlyColor && (
              <>
                <SelectImageButton
                  image={props.image.value}
                  onClick={openWarehouse}
                />
                <RemoveImageButton
                  image={props.image.value}
                  onClick={removeImage}
                />
              </>
            )}
          </div>
          <OutsideClickHandler onOutsideClick={closeColorPicker}>
            {displayColorPicker && (
              <ColorPicker
                color={color}
                onChange={handleColorChange}
                defaultColor={defaultColor}
                presetColors={usedColors(props)}
              />
            )}
          </OutsideClickHandler>
        </div>
      </div>
      {!onlyColor && <ImageSettings {...props} />}
    </>
  );
};

export default Settings;
